// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userBadge_badge_wrap__3jxps {
  display: flex;
  flex-direction: row;
  gap: 10px;
  height: 50px;
  margin-left: 30px;
  align-items: flex-end;
}
.userBadge_badge_wrap__3jxps .userBadge_info_wrapp__GKFcV {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.userBadge_badge_wrap__3jxps .userBadge_info__IQFZR {
  margin-right: 10px;
  text-align: end;
  width: max-content;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 5px 0;
}
.userBadge_badge_wrap__3jxps .userBadge_info__IQFZR .userBadge_name__Ovfja {
  width: max-content;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
}
.userBadge_badge_wrap__3jxps .userBadge_info__IQFZR .userBadge_position__IDqU9 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
}
.userBadge_badge_wrap__3jxps img {
  object-fit: cover;
  border-radius: 50%;
  height: 50px;
  width: 50px;
}
@media (max-width: 991px) {
  .userBadge_badge_wrap__3jxps {
    height: 40px;
    align-items: center;
  }
  .userBadge_badge_wrap__3jxps .userBadge_info__IQFZR .userBadge_name__Ovfja {
    font-size: 16px;
    line-height: 22px;
  }
  .userBadge_badge_wrap__3jxps .userBadge_info__IQFZR .userBadge_position__IDqU9 {
    font-weight: 400;
  }
  .userBadge_badge_wrap__3jxps img {
    height: 40px;
    width: 40px;
  }
}
@media (max-width: 800px) {
  .userBadge_badge_wrap__3jxps {
    margin-left: 5px;
  }
  .userBadge_badge_wrap__3jxps .userBadge_info__IQFZR .userBadge_name__Ovfja {
    font-size: 16px;
    line-height: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .userBadge_badge_wrap__3jxps .userBadge_info__IQFZR .userBadge_position__IDqU9 {
    font-size: 12px;
  }
  .userBadge_badge_wrap__3jxps img {
    height: 30px;
    width: 30px;
  }
}

.userBadge_badge_dropdown__uqnuS {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: max-content;
  cursor: pointer;
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
}
.userBadge_badge_dropdown__uqnuS div {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column-reverse;
}
.userBadge_badge_dropdown__uqnuS div svg {
  height: 30px;
}
.userBadge_badge_dropdown__uqnuS:hover {
  color: var(--primary-color);
  transition: all 0.3s;
}
.userBadge_badge_dropdown__uqnuS:hover svg {
  fill: var(--primary-color);
}
.userBadge_badge_dropdown__uqnuS:hover svg g {
  fill: var(--primary-color);
  transition: all 0.3s;
}
.userBadge_badge_dropdown__uqnuS .userBadge_enter_cabinet__Y9Dlm {
  margin-bottom: 10px;
}
.userBadge_badge_dropdown__uqnuS .userBadge_logout__RKRa0 {
  width: fit-content;
  height: 100%;
}
.userBadge_badge_dropdown__uqnuS:hover {
  background-color: white;
  box-shadow: 0 0 10px 1px rgb(195, 195, 195);
  border-radius: 5px;
}
@media (max-width: 991px) {
  .userBadge_badge_dropdown__uqnuS {
    flex-direction: row;
    gap: 5px;
  }
  .userBadge_badge_dropdown__uqnuS div {
    flex-direction: row;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/UserBadge/userBadge.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AACJ;AAEE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAAJ;AAEI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAN;AAGI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AADN;AAKE;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAHJ;AAME;EA7CF;IA8CI,YAAA;IACA,mBAAA;EAHF;EAMI;IACE,eAAA;IACA,iBAAA;EAJN;EAOI;IACE,gBAAA;EALN;EASE;IACE,YAAA;IACA,WAAA;EAPJ;AACF;AAUE;EAlEF;IAmEI,gBAAA;EAPF;EAUI;IACE,eAAA;IACA,cAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;EARN;EAWI;IACE,eAAA;EATN;EAaE;IACE,YAAA;IACA,WAAA;EAXJ;AACF;;AAeA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EAEA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAbF;AAeE;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,8BAAA;AAdJ;AAgBI;EACE,YAAA;AAdN;AAiBE;EACE,2BAAA;EACA,oBAAA;AAfJ;AAiBI;EACE,0BAAA;AAfN;AAgBM;EACE,0BAAA;EACA,oBAAA;AAdR;AAmBE;EACE,mBAAA;AAjBJ;AAoBE;EACE,kBAAA;EACA,YAAA;AAlBJ;AAqBE;EACE,uBAAA;EACA,2CAAA;EACA,kBAAA;AAnBJ;AAsBE;EArDF;IAsDI,mBAAA;IACA,QAAA;EAnBF;EAoBE;IACE,mBAAA;EAlBJ;AACF","sourcesContent":[".badge_wrap {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  height: 50px;\n  margin-left: 30px;\n  align-items: flex-end;\n\n  .info_wrapp {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 5px;\n  }\n\n  .info {\n    margin-right: 10px;\n    text-align: end;\n    width: max-content;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding: 5px 0;\n\n    .name {\n      width: max-content;\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 24px;\n    }\n\n    .position {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 1;\n    }\n  }\n\n  img {\n    object-fit: cover;\n    border-radius: 50%;\n    height: 50px;\n    width: 50px;\n  }\n\n  @media (max-width: 991px) {\n    height: 40px;\n    align-items: center;\n\n    .info {\n      .name {\n        font-size: 16px;\n        line-height: 22px;\n      }\n\n      .position {\n        font-weight: 400;\n      }\n    }\n\n    img {\n      height: 40px;\n      width: 40px;\n    }\n  }\n\n  @media (max-width: 800px) {\n    margin-left: 5px;\n\n    .info {\n      .name {\n        font-size: 16px;\n        line-height: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n      .position {\n        font-size: 12px;\n      }\n    }\n\n    img {\n      height: 30px;\n      width: 30px;\n    }\n  }\n}\n\n.badge_dropdown {\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n  width: max-content;\n\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 400;\n\n  div {\n    cursor: pointer;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: column-reverse;\n\n    svg {\n      height: 30px;\n    }\n  }\n  &:hover {\n    color: var(--primary-color);\n    transition: all 0.3s;\n\n    svg {\n      fill: var(--primary-color);\n      g {\n        fill: var(--primary-color);\n        transition: all 0.3s;\n      }\n    }\n  }\n\n  .enter_cabinet {\n    margin-bottom: 10px;\n  }\n\n  .logout {\n    width: fit-content;\n    height: 100%;\n  }\n\n  &:hover {\n    background-color: white;\n    box-shadow: 0 0 10px 1px rgb(195, 195, 195);\n    border-radius: 5px;\n  }\n\n  @media (max-width: 991px) {\n    flex-direction: row;\n    gap: 5px;\n    div {\n      flex-direction: row;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge_wrap": `userBadge_badge_wrap__3jxps`,
	"info_wrapp": `userBadge_info_wrapp__GKFcV`,
	"info": `userBadge_info__IQFZR`,
	"name": `userBadge_name__Ovfja`,
	"position": `userBadge_position__IDqU9`,
	"badge_dropdown": `userBadge_badge_dropdown__uqnuS`,
	"enter_cabinet": `userBadge_enter_cabinet__Y9Dlm`,
	"logout": `userBadge_logout__RKRa0`
};
export default ___CSS_LOADER_EXPORT___;
